<template lang="pug">
div(v-if='!loading')
  .unit(:class='{ "unit--off": !power, small: size === 250 }')
    //- Barra de navegación
    van-nav-bar(:title='device.name', left-arrow, @click-left='back')
      van-icon(
        name='info',
        slot='right',
        :class='{ errorTemp: device.tsensor_error }',
        @click='showInfo'
      )

    .main.padding-double-bottom.text--center(v-if='device')
      //- Botones Encendido/Apagado/Temperatura local
      .unit__header(:class='{ master: device.master, blockUnit: blockDevice }')
        button.powerOff.powerOff--big(
          :class='{ "powerOff--select": power, unitTransparent: device.block_off || fallback }',
          @click='swithOff'
        )

        .unit__header__temp(:class='{ errorTemp: device.tsensor_error }')
          span(v-if='!ACSMode')
            van-icon(name='temp')
            span.tempSensor(v-if='device.work_temp_selec_sensor') {{ device.work_temp_selec_sensor }}
            span(v-if='isNaN(localTemp)') --
            span(v-else) {{ Math.round(localTemp) }}
            span.unitType {{ tempUnit }}

          span(v-if='ACSMode')
            van-icon(name='unit-acs-9')
            | {{ Math.round(device.acs_temp) }}
            span.unitType {{ tempUnit }}

          span.margin-halve-left(v-if='device.ext_temp')
            van-icon(name='temp-ext')
            | {{ Math.round(device.ext_temp) }}
            span.unitType {{ tempUnit }}

        button.powerOn.powerOn--big(
          :class='{ "powerOn--select": power, unitTransparent: device.block_on || fallback }',
          @click='switchOn'
        )

      //- Botones de modo
      .unit__modes(
        v-if='!ACSMode && device && device.mode_available',
        :class='["unit__modes__" + device.mode_available.length]'
      )
        van-icon(
          v-for='(mode, key) in device.mode_available',
          :name='GetModeIcon(mode)',
          :key='key',
          :class='{ select: mode === modeValue, unitTransparent: device.block_mode || fallback }',
          @click='setMode(mode)'
        )

      .unit__modes.unit__modes__1(v-if='ACSMode')
        van-icon.select(name='heating')

      //- Selector de temperatura
      knob-control.unit__temp(
        :value='getSetPoint',
        :size='size',
        :strokeWidth='50',
        :angleOffset='55',
        :angleArc='250',
        :valMin='minTemp',
        :valMax='maxTemp',
        :rangeColor='modeColor',
        :readonly='isDisable',
        :blocked='device.block_setpoint || (device.power_hot_water && ACSMode) || fallback',
        :mode='modeTitle',
        :modeValue='modeValue',
        :units='tempUnit',
        :showDecimal='showDecimal',
        :stepSize='stepSize',
        :class='{ disabled: isDisable, unitTransparent: device.block_setpoint || (device.power_hot_water && ACSMode) || fallback }',
        valueColor='transparent',
        @changeKnob='setPoint'
      )

      //- Calor auxiliar
      .unit__footer__line(v-if='showEmergencyHeat')
        van-switch-cell(
          v-model='device.emerheatstatus',
          :title='$t("auxheat.emergencyheat")',
          @change='setEmergencyHeat'
        )

      //- Calidad del aire
      .unit__iq(
        v-if='device.aqpresent && device.aqready && device.power',
        @click='showIQRange',
        :class='"unit__iq--" + iq'
      )
        van-icon(name='iq')
        span.margin-quarter-left(v-if='iq === "good"') {{ $t("iq.iqGood") }}
        span.margin-quarter-left(v-else-if='iq === "bad"') {{ $t("iq.iqBad") }}
        span.margin-quarter-left(v-else) {{ $t("iq.iqRegular") }}

      .unit__iq(v-if='device.aqpresent && !device.aqready && device.power')
        van-icon(name='warning1')
        span.margin-quarter-left.text-danger {{ $t("iq.iqNotConected") }}

      //- .unit__ppm(v-if='device.aqpresent && device.power')
        .unit__ppm__item(v-if='device.aqpm1_0 >= 0')
          | {{ device.aqpm1_0 }}
          span.small 1.5 PM
        .unit__ppm__item(v-if='device.aqpm2_5 >= 0')
          | {{ device.aqpm2_5 }}
          span.small 2.5 PM
        .unit__ppm__item(v-if='device.aqpm10 >= 0')
          | {{ device.aqpm10 }}
          span.small 10 PM

      //- Dispostivos de terceros
      .unit__devices(v-if='device.link_deviceID')
        | {{ device.link_manufacturer }} {{ $t("devices.thermostat") }}
      .unit__devices__name(v-if='device.link_name_thermostat')
        | {{ device.link_name_thermostat }}

    //- Footer
    .unit__footer
      //- Próxima programación
      .unit__footer__block(:class='{ unit__footer__noSchedule: !nextSchedule }')
        div(v-if='nextSchedule', @click='goToSchedules')
          .unit__footer__line.unit__footer__line--date
            van-icon(name='schedule')
            | {{ $t(`schedule.shortDay.${nextSchedule.dayString}`) }} -&nbsp;
            span(v-html='getTime(nextSchedule.hour, nextSchedule.minutes)')
          .unit__footer__line(v-if='nextSchedule.power')
            van-icon(:name='GetModeIcon(nextSchedule.mode)')
            | {{ nextSchedule.setpoint }}
            span.unitType {{ tempUnit }}
          .unit__footer__line(v-if='!nextSchedule.power')
            | OFF

        div(v-if='!ACSMode && !nextSchedule', @click='goToSchedules')
          van-icon(name='schedule')

      .unit__footer__block
        //- Control del ionizador
        .unit__footer__iq(@click='showIQ', v-if='device.aqpresent && device.aqready')
          van-icon(name='iqOff', v-if='device.aqmode === IQ_MODE.OFF')
          van-icon(
            name='iqOn',
            v-if='device.aqmode === IQ_MODE.ON',
            :class='{ select: device.power }'
          )
          van-icon(
            name='iqAuto',
            v-if='device.aqmode === IQ_MODE.AUTO',
            :class='{ select: device.power }'
          )

        //- Control de Lamas
        .unit__footer__slats(
          v-if='!ACSMode && device.slats_vnum && device.slats_vertical_1 !== undefined',
          @click='showSlats("vertical")',
          :class='{ unitTransparent: fallback }'
        )
          van-icon(name='auto', v-if='device.slats_vertical_1 === SLATS_MODE.AUTO')
          van-icon(name='vswing', v-if='device.slats_vertical_1 === SLATS_MODE.SWING')
          van-icon(name='vfixe', v-if='device.slats_vertical_1 < SLATS_MODE.AUTO')

        .unit__footer__slats(
          v-if='!ACSMode && device.slats_hnum && device.slats_horizontal_1 !== undefined',
          @click='showSlats("horizontal")',
          :class='{ unitTransparent: fallback }'
        )
          van-icon(name='auto', v-if='device.slats_horizontal_1 === SLATS_MODE.AUTO')
          van-icon(name='hswing', v-if='device.slats_horizontal_1 === SLATS_MODE.SWING')
          van-icon(name='hfixe', v-if='device.slats_horizontal_1 < SLATS_MODE.AUTO')

        //- Control de velocidad
        .unit__footer__fan(
          v-if='!ACSMode && device.speed_state >= 0 && device.mode !== MODES.DRY',
          @click='showFan',
          :class='{ unitTransparent: fallback }'
        )
          van-icon(:name='"fan" + listSpeedFan[device.speed_state]')

        //- Máxima potencia
        .unit__footer__powerful(
          v-if='ACSMode',
          @click='switchPowerful',
          :class='{ "powerful--select": device.power_hot_water, unitTransparent: fallback }'
        )
          van-icon(name='powerful')

  //- Modal con la ventana de información del dispositivo
  van-popup.unit__webserver__popup(v-model='showDeviceInfo')
    DeviceModalInfo(
      v-if='showDeviceInfo',
      :mac='mac',
      :installationID='installationID',
      @close='hideInfo'
    )

  //- Modal con la ventana de lamas
  van-popup.unit__slats__popup(v-model='showSlatsVericalSelector', position='bottom')
    SlatsSelector(
      :vertical='true',
      :step='device.slats_vertical_1',
      :steps='device.slats_vnum',
      :auto='device.slats_autoud',
      :swing='device.slats_swingud',
      @setSlat='setSlat',
      @close='hideSlats'
    )

  van-popup.unit__slats__popup(v-model='showSlatsHorizontalSelector', position='bottom')
    SlatsSelector(
      :vertical='false',
      :step='device.slats_horizontal_1',
      :steps='device.slats_hnum',
      :auto='device.slats_autolr',
      :swing='device.slats_swinglr',
      @setSlat='setSlat',
      @close='hideSlats'
    )

  //- Modal con la ventana de IQ
  van-popup.unit__iq__popup(v-model='showIQSelector', position='bottom')
    IQSelector(:aqmode='device.aqmode', @setIQ='setIQ', @close='hideIQ')

  //- Modal con la ventana del IQ Range
  van-popup.unit__iq__popup(
    v-if='showIQRangeSelector',
    v-model='showIQRangeSelector',
    position='bottom'
  )
    IQRangeSelector(
      :iqLow='device.aqthrlow',
      :iqHigh='device.aqthrhigh',
      @setIQRange='setIQRange',
      @close='hideIQRange'
    )

  //- Modal con la ventana de velocidades
  van-popup.unit__fan__popup(v-if='showFanSelector', v-model='showFanSelector', position='bottom')
    SpeedFanSelector(
      :speeds='listSpeedFan',
      :speed='device.speed_state',
      @setFan='setFan',
      @close='hideFan'
    )
</template>

<script>
import i18n from '@/locales/i18n';
import Unit from '@/mixins/Unit.mixin';
import GetModeTitle from '@/mixins/GetModeTitle.mixin';
import GetModeIcon from '@/mixins/GetModeIcon.mixin';
import Time from '@/mixins/Time.mixin';
import knobControl from '@/components/Unit/knob.vue';
import SpeedFanSelector from '@/components/Unit/SpeedFanSelector.vue';
import SlatsSelector from '@/components/Unit/SlatsSelector.vue';
import DeviceModalInfo from '@/components/DeviceModalInfo.vue';
import IQSelector from '@/components/Unit/IQSelector.vue';
import IQRangeSelector from '@/components/Unit/IQRangeSelector.vue';
import { MODES, TAI, SLATS_MODE, UNITS, IQ_MODE } from '@/app.config';
import { parseBoolean } from '@/utils/sanitaze.utils';
import { mapGetters } from 'vuex';

export default {
  components: {
    knobControl,
    SpeedFanSelector,
    SlatsSelector,
    DeviceModalInfo,
    IQSelector,
    IQRangeSelector,
  },
  mixins: [Unit, GetModeTitle, GetModeIcon, Time],
  data() {
    return {
      ACSMode: false,
      mac: '',
      installationID: '',
      size: screen.height > 645 ? 280 : 250, // eslint-disable-line
      disableAutoTimer: false,
      showDeviceInfo: false,
      showSlatsVericalSelector: false,
      showSlatsHorizontalSelector: false,
      showFanSelector: false,
      showIQSelector: false,
      showIQRangeSelector: false,
      SLATS_MODE,
      MODES,
      IQ_MODE,
    };
  },
  computed: {
    ...mapGetters({
      getNextSchedule: 'unitsModule/getNextSchedule',
    }),

    /**
     * Devuelve el color según el modo
     */
    modeColor() {
      if (!this.power) {
        return '#C5C8CA';
      }

      if (this.ACS && this.ACSMode) {
        return '#ec5438';
      }

      // El modo auto, puede funcionar como auto calor o auto frio
      // este valor me llega en el parámetro real_mode
      // si no coincide con ninguno, muestro el color del auto
      if (this.device.mode === MODES.AUTO && this.device.real_mode) {
        switch (this.device.real_mode) {
          case MODES.COOLING:
            return '#31A2ED';
          case MODES.HEATING:
            return '#ec5438';
          default:
            return '#0099cc';
        }
      }

      switch (this.device.mode) {
        case MODES.AUTO:
          return '#0099cc';
        case MODES.COOLING:
          return '#31A2ED';
        case MODES.HEATING:
          return '#ec5438';
        case MODES.FAN:
          return '#7bb032';
        case MODES.DRY:
          return '#5daed3';
        default:
          return '#0099cc';
      }
    },

    /**
     * Devuelve el nombre del modo de funcionamiento
     */
    modeTitle() {
      return this.GetModeTitle(this.device.mode, this.ACSMode);
    },

    /**
     * Devuelve si muestra el calor de emergencia
     */
    showEmergencyHeat() {
      if (this.device.emerheatpresent && this.device.mode === 3) {
        return true;
      }

      return false;
    },

    /**
     * Devuelve el valor del modo
     */
    modeValue() {
      if (this.ACSMode) {
        return MODES.HEATING;
      }

      return this.device.mode;
    },

    /**
     * Devuelve si la unidad está apagada o desactivada
     */
    isDisable() {
      if (
        (this.modeValue === MODES.AUTO && !this.disableAutoTimer) ||
        this.modeValue === MODES.COOLING ||
        this.modeValue === MODES.HEATING
      ) {
        return false;
      }
      return true;
    },

    /**
     * Devuelve un Array con las velocidades disponibles
     */
    listSpeedFan() {
      const speeds = this.device.speed_available;
      if (!speeds) return null;

      const auto = speeds.indexOf(0);
      const speedsObject = {};

      speeds.forEach((fan, key) => {
        key = auto > -1 ? key : key + 1;
        speedsObject[fan] = key;
      });

      return speedsObject;
    },

    /**
     * Devuelve el salto de temperatura, por defecto es de 1º
     * pero en las unidades altherma es de 0.5º
     */
    stepSize() {
      return this.device.acs_available && this.device.tai_th && !this.ACSMode ? 0.5 : 1;
    },

    nextSchedule() {
      return this.getNextSchedule(this.installationID, this.mac, this.ACSMode);
    },

    showDecimal() {
      return this.units === UNITS.CELSIUS && this.device.setpoint_step;
    },

    iq() {
      if (this.device.aqpm2_5 < this.device.aqthrlow) return 'good';
      if (this.device.aqpm2_5 > this.device.aqthrhigh) return 'bad';
      return 'regular';
    },
  },
  watch: {
    deviceFail(newValue) {
      if (!this.loading && newValue) {
        this.$dialog
          .alert({
            title: newValue,
          })
          .then(() => {
            this.back();
          });
      } else {
        this.$dialog.close();
      }
    },
  },
  methods: {
    /**
     * Cambia el modo del dispositivo
     *
     * Si está bloqueada esta acción muestra un mensaje
     * Si el dispositivo tienen algún error o es el mismo modo, no hace nada
     */
    setMode(mode) {
      if (this.device.block_mode) {
        this.$toast.fail({
          duration: 1500,
          message: i18n.t('unit.block'),
          mask: true,
        });
        return;
      }

      if (this.fallback) {
        this.$toast.fail({
          duration: 2000,
          message: i18n.t('unit.fallback'),
          mask: true,
        });
        return;
      }

      if (this.deviceFail || mode === this.modeValue) return;

      /**
       * No siempre sabemos si la unidad dispone de modo auto, temporalmente se ha tomado
       * la solución de añadir un timer y dejar bloqueado el cambio de modo durante unos
       * segundos para comprobar si devuelve o no un cambio de modo, lo que implicaría que
       * la unidad no soporta el modo automático
       */
      if (mode === MODES.AUTO) {
        this.disableAutoTimer = true;
        setTimeout(() => {
          this.disableAutoTimer = false;
        }, 5000);
      }

      this.setProperty('mode', mode, 0);

      /**
       * Siempre que cambiamos de modo debemos enviar la temperatura
       */
      // eslint-disable-next-line default-case
      switch (mode) {
        case MODES.AUTO:
          if (this.device.acs_available && this.device.tai_th === TAI.WATER) {
            this.setProperty('setpoint_water_auto', this.device.setpoint_water_auto, 0);
          } else {
            this.setProperty('setpoint_air_auto', this.device.setpoint_air_auto, 0);
          }
          break;
        case MODES.COOLING:
          if (this.device.acs_available && this.device.tai_th === TAI.WATER) {
            this.setProperty('setpoint_water_cool', this.device.setpoint_water_cool, 0);
          } else {
            this.setProperty('setpoint_air_cool', this.device.setpoint_air_cool, 0);
          }
          break;
        case MODES.HEATING:
          if (this.device.acs_available && this.device.tai_th === TAI.WATER) {
            this.setProperty('setpoint_water_heat', this.device.setpoint_water_heat, 0);
          } else {
            this.setProperty('setpoint_air_heat', this.device.setpoint_air_heat, 0);
          }
          break;
      }
    },

    /**
     * Cambia el setPoint del dispositivo
     *
     * Si está bloqueada esta acción muestra un mensaje
     * Si el dispositivo tienen algún error, no hace nada
     * Antes de enviar el nuevo setPoint compruebo que se encuentra dentro del rango
     */
    setPoint(newPoint) {
      if (this.device.block_setpoint) {
        this.$toast.fail({
          duration: 1500,
          message: i18n.t('unit.block'),
          mask: true,
        });
        return;
      }

      if (this.fallback) {
        this.$toast.fail({
          duration: 2000,
          message: i18n.t('unit.fallback'),
          mask: true,
        });
        return;
      }

      if (this.device.power_hot_water && this.ACSMode) {
        this.$toast.fail({
          duration: 1500,
          message: i18n.t('unit.blockPowerful'),
          mask: true,
        });
        return;
      }

      if (this.deviceFail) return;

      if (this.ACS && this.ACSMode) {
        if (newPoint === this.device.setpoint_acs) return;
        if (newPoint >= this.device.range_sp_acs_max) {
          newPoint = this.device.range_sp_acs_max;
        }
        if (newPoint <= this.device.range_sp_acs_min) {
          newPoint = this.device.range_sp_acs_min;
        }
        this.setProperty('setpoint_acs', newPoint, 1500);
      } else if (
        this.modeValue === 2 &&
        this.device.acs_available &&
        this.device.tai_th === TAI.WATER
      ) {
        if (newPoint === this.device.setpoint_water_cool) return;
        if (newPoint >= this.device.range_sp_cool_water_max) {
          newPoint = this.device.range_sp_cool_water_max;
        }
        if (newPoint <= this.device.range_sp_cool_water_min) {
          newPoint = this.device.range_sp_cool_water_min;
        }
        this.setProperty('setpoint_water_cool', newPoint, 1500);
      } else if (this.modeValue === 2) {
        if (newPoint === this.device.setpoint_air_cool) return;
        if (newPoint >= this.device.range_sp_cool_air_max) {
          newPoint = this.device.range_sp_cool_air_max;
        }
        if (newPoint <= this.device.range_sp_cool_air_min) {
          newPoint = this.device.range_sp_cool_air_min;
        }
        this.setProperty('setpoint_air_cool', newPoint, 1500);
      } else if (
        this.modeValue === 3 &&
        this.device.acs_available &&
        this.device.tai_th === TAI.WATER
      ) {
        if (newPoint === this.device.setpoint_water_heat) return;
        if (newPoint >= this.device.range_sp_hot_water_max) {
          newPoint = this.device.range_sp_hot_water_max;
        }
        if (newPoint <= this.device.range_sp_hot_water_min) {
          newPoint = this.device.range_sp_hot_water_min;
        }
        this.setProperty('setpoint_water_heat', newPoint, 1500);
      } else if (this.modeValue === 3) {
        if (newPoint === this.device.setpoint_air_heat) return;
        if (newPoint >= this.device.range_sp_hot_air_max) {
          newPoint = this.device.range_sp_hot_air_max;
        }
        if (newPoint <= this.device.range_sp_hot_air_min) {
          newPoint = this.device.range_sp_hot_air_min;
        }
        this.setProperty('setpoint_air_heat', newPoint, 1500);
      } else if (
        this.modeValue === 1 &&
        this.device.acs_available &&
        this.device.tai_th === TAI.WATER
      ) {
        if (newPoint === this.device.setpoint_water_auto) return;
        if (newPoint >= this.device.range_sp_auto_water_max) {
          newPoint = this.device.range_sp_auto_water_max;
        }
        if (newPoint <= this.device.range_sp_auto_water_min) {
          newPoint = this.device.range_sp_auto_water_min;
        }
        this.setProperty('setpoint_water_auto', newPoint, 1500);
      } else if (this.modeValue === 1) {
        if (newPoint === this.device.setpoint_air_auto) return;
        if (newPoint >= this.device.range_sp_auto_air_max) {
          newPoint = this.device.range_sp_auto_air_max;
        }
        if (newPoint <= this.device.range_sp_auto_air_min) {
          newPoint = this.device.range_sp_auto_air_min;
        }
        this.setProperty('setpoint_air_auto', newPoint, 1500);
      }
    },

    /**
     * Cambia el calor de emergencia
     *
     */
    setEmergencyHeat() {
      this.setProperty('emerheatstatus', this.device.emerheatstatus);
    },

    /**
     * Cambia la velocidad de ventilación
     *
     * Si el dispositivo tienen algún error, no hace nada
     */
    setFan(speed) {
      if (this.deviceFail || speed === this.device.speed_state) return;
      this.hideFan();
      this.setProperty('speed_state', speed);
    },

    /**
     * Cambia los valores de IQ
     *
     */
    setIQ(aqmode) {
      this.hideIQ();
      this.setProperty('aqmode', aqmode);
    },

    /**
     * Cambia los valores de IQ
     *
     * Si el dispositivo tienen algún error, no hace nada
     */
    setIQRange(aqRange) {
      this.hideIQRange();
      this.setProperty('aqthrlow', aqRange.low, 0);
      this.setProperty('aqthrhigh', aqRange.high, 0);
    },

    /**
     * Cambia la posición de las lamas
     */
    setSlat(data) {
      const vertical = data.vertical;
      const value = data.value;

      if (vertical) {
        this.setProperty('slats_vertical_1', value);
      } else {
        this.setProperty('slats_horizontal_1', value);
      }

      // console.log('setStat in device', this.device);
    },

    /**
     * Muestra un modal con información del dispositivo
     */
    showInfo() {
      this.showDeviceInfo = true;
    },

    /**
     * Oculta un modal con información del dispositivo
     */
    hideInfo() {
      this.showDeviceInfo = false;
    },

    /**
     * Muestra un modal con el selector de velocidades
     */
    showFan() {
      if (this.fallback) {
        this.$toast.fail({
          duration: 2000,
          message: i18n.t('unit.fallback'),
          mask: true,
        });
        return;
      }

      this.showFanSelector = true;
    },

    /**
     * Oculta el modal con el selector de velocidades
     */
    hideFan() {
      this.showFanSelector = false;
    },

    /**
     * Muestra un modal con el selector de lamas
     */
    showSlats(direction) {
      if (this.fallback) {
        this.$toast.fail({
          duration: 2000,
          message: i18n.t('unit.fallback'),
          mask: true,
        });
        return;
      }

      if (direction === 'vertical') this.showSlatsVericalSelector = true;
      else this.showSlatsHorizontalSelector = true;
    },

    /**
     * Oculta el modal con el selector de lamas
     */
    hideSlats() {
      this.showSlatsVericalSelector = false;
      this.showSlatsHorizontalSelector = false;
    },

    showIQ() {
      this.showIQSelector = true;
    },

    hideIQ() {
      this.showIQSelector = false;
    },

    showIQRange() {
      this.showIQRangeSelector = true;
    },

    hideIQRange() {
      this.showIQRangeSelector = false;
    },

    /**
     * Vuelve a la vista previa
     */
    back() {
      this.$router.back();
    },

    /**
     * Enlaza con la vista programaciones
     * Si hay una programación, se muestra seleccionado el día de la programación al ir a la vista
     */
    goToSchedules() {
      if (this.nextSchedule) {
        this.$router.push({ name: 'schedules', params: { day: this.nextSchedule.day } });
      } else {
        this.$router.push({ name: 'schedules' });
      }
    },
  },
  created() {
    this.mac = this.$route.params.mac;
    this.installationID = this.$route.params.installationID;
    this.ACSMode = parseBoolean(this.$route.params.ACSMode);
  },
};
</script>

<style lang="scss">
.van-cell {
  &__title {
    flex: 2;
    overflow: hidden;
    text-overflow: initial;
    white-space: initial;
  }
}
</style>
